// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*兼容IE浏览器没有 promise 的情况*/
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue'
import App from './App'
// 路由
import router from './router'
//vuex 状态容器
import store from "./extra/store"

/*公共css 样式*/
import "@/assert/css/common.css"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// i18n 必须在 Vue.use(ElementUI) 之后引入，桥接函数才能覆盖 Element UI 默认的中文文案
import i18n, { loadLanguage } from './i18n'
import { getLanguage } from './extra/language'

/*
* 引入插件功能
* */
import plugin from "./extra/plugin"
Vue.use(plugin);

import hotKey from "./extra/hotKey"
Vue.use(hotKey)

/*导入 全局jquery*/
import $ from "jquery";

/*
引入 bootStrap 包，
注意：引入 bootstrap 需要引入 jquery
*/
import "./assert/css/bootstrap.css"
import "./assert/css/font-awesome.min.css"
import "./assert/css/ace.min.css"

Vue.config.productionTip = false;

getLanguage().then(({ language, languageList }) => {
  /* eslint-disable no-new */
// 语言包是按需拉取的独立 chunk，等它到位再挂载，避免首屏闪现 key 名
  loadLanguage(language).then(() => new Vue({
    el: '#app',
    router,
    store,
    i18n,
    provide() { return { languageList } },
    components: { App },
    template: '<App/>'
  }));
});




// WEBPACK FOOTER //
// ./src/main.js